const royerReviewsSection = document.getElementById("royer-reviews-section");
const royerHeaderScoreWrapper = document.querySelector(".reviews-left-section");
const royerNoReviewWrapper = document.querySelector(".royer-reviews-no-review-wrapper");
const royerReviewOrderingWrapper = document.querySelector(".review-entry-sort");
const royerReviewOrderingSelect = document.getElementById("royer-reviews-orderering-select");
const reviewEntriesWrapper = document.querySelector(".review-entries-wrapper");
const royerReviewTemplate = document.getElementById("review-entry-wrapper-template");
const royerReviewsErrorToast = document.getElementById("royer-reviews-error-toast");
const royerReviewplaceholders = Array.from(document.getElementsByClassName("review-placeholder"));
const royerReviewsLoadMoreWrapper = document.querySelector(".royer-reviews-load-more-wrapper");
const royerReviewsLoadMoreBtn = document.querySelector(".royer-reviews-load-more-btn");
const royerReviewsLoadMoreBtnText = document.querySelector(".royer-reviews-load-more-btn-text");
const royerReviewsLoadMoreBtnSpinner = document.querySelector(".royer-reviews-load-more-btn-spinner");

let royerReviewsErrorToastBootstrap;

const reviewListPageSize = 10;
let reviewListCrtPage = 0;

const reviewListIntersectionObserverCallback = (entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      reviewListIntersectionObserver.unobserve(entry.target);
      LoadReviews();
    }
  });
};

const reviewListIntersectionObserver = new IntersectionObserver(
  reviewListIntersectionObserverCallback
);

//Only do all the loading review logic if there is at least one review
if (!royerNoReviewWrapper){
  reviewListIntersectionObserver.observe(royerReviewsSection);
  
  document.addEventListener("DOMContentLoaded", (event) => {
    royerReviewsErrorToastBootstrap = bootstrap.Toast.getOrCreateInstance(
      royerReviewsErrorToast,
      { delay: 5000 }
    );
  });
  
  royerReviewOrderingSelect.addEventListener("change", () => {
    reviewListCrtPage = 0;
    LoadReviews();
  });

  royerReviewsLoadMoreBtn.addEventListener("click", () => LoadReviews(reviewListPageSize, reviewListCrtPage, false));
}

function LoadReviews(
  pageSize = reviewListPageSize,
  pageNb = reviewListCrtPage,
  firstLoad = true
) {
  if (firstLoad) {
    const realReviews = Array.from(
      document.querySelectorAll(
        ".review-entry-wrapper:not(.review-placeholder,#review-entry-wrapper-template)"
      )
    );
    loadingAnimationReviews(true);
    realReviews.forEach((review) => review.remove());
  }
  else{
    royerReviewsLoadMoreBtn.disabled = true;
    royerReviewsLoadMoreBtnText.classList.add("invisible");
    royerReviewsLoadMoreBtnSpinner.classList.remove("d-none");
  }

  const prodUrl = "https://api3.royer.com/api/reviews/get-reviews";
  const devUrl = "https://localhost:44318/api/reviews/get-reviews";

  const postUrl = prodUrl;

  const myHeaders = new Headers();
  myHeaders.append(
    "Authorization",
    "Basic TVZobGVsa3FScDk0TlI2NTFseXM6c2ZIUnpVT1FGcEcxclJ6WGx1bE0="
  );
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Content-Length", "0");

  const request = {
    references_whitelist: [
      product.title,
      ...product.otherColorProducts.map((product) => product.title),
    ],
    include_empty_body_reviews: false,
  };

  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    scheme: "https",
    mode: "cors",
    cache: "no-cache",
    body: JSON.stringify(request),
  };

  fetch(
    postUrl +
      "?size=" +
      pageSize +
      "&page=" +
      pageNb +
      "&ordering=" +
      royerReviewOrderingSelect.value,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => {
      result = JSON.parse(result);
      if (result?.items) {
        if (result.has_next_page) royerReviewsLoadMoreWrapper.classList.remove("d-none");
        else royerReviewsLoadMoreWrapper.classList.add("d-none");
        
        result.items.forEach((review) => {
          newReviewEl = royerReviewTemplate.cloneNode(true);
          //Wiping the id of the template element
          newReviewEl.id = "";
          reviewEntriesWrapper.appendChild(newReviewEl);
          //Making sure that any script inside the copied element is ran (script is ran if you directly append it instead of it being a child of the element being appended)
          Array.from(newReviewEl.querySelectorAll("script")).forEach(script => {
            // Create a new script element
            const newScript = document.createElement("script");
            newScript.textContent = script.textContent;
            // Replace the old script with the new one
            script.parentNode.replaceChild(newScript, script);
          });
          //Filling stars
          const roundedNearestHalfInt = Math.round(review.rating*2)/2;
          const starSvgs = Array.from(newReviewEl.querySelectorAll(".royer-reviews-star-wrapper svg.star-svg"));
          for (let i = 0;i <= roundedNearestHalfInt - 1;i++){
            starSvgs[i].classList.add("full");
          }
          if (roundedNearestHalfInt % 1 != 0) starSvgs[Math.floor(roundedNearestHalfInt)].classList.add("half-full")
          //Filling country
          if (review.country_code != null){
            newReviewEl.querySelector(".royer-reviews-country").innerText = countryTranslation[review.country_code];
          }
          //Filling region
          if (review.region_code != null){
            newReviewEl.querySelector(".royer-reviews-region").innerText = ", " + review.region_code;
          }
          //Filling date
          const creationDate = new Date(review.creation_date);
          const yyyy = creationDate.getFullYear();
          let mm = creationDate.getMonth() + 1;
          let dd = creationDate.getDate();
          if (dd < 10) dd = '0' + dd;
          if (mm < 10) mm = '0' + mm;
          newReviewEl.querySelector(".royer-reviews-date").innerText = dd + '/' + mm + '/' + yyyy;
          //Filling reviewer name
          newReviewEl.querySelector(".review-entry-reviewer-name").innerText = review.name;
          //Showing or hiding verified customer tag
          const verifiedValues = [
            "confirmed-buyer",
            "buyer",
            "verified-purchase",
            "admin",
          ];
          const verifiedWrapper = newReviewEl.querySelector(".review-entry-verified");
          if (verifiedValues.includes(review.verified))
            verifiedWrapper.classList.remove("d-none");
          else verifiedWrapper.classList.add("d-none");
          //Filling model link
          const modelLink = newReviewEl.querySelector(".review-entry-model-link");
          modelLink.innerText = review.product_title;
          if (review.product_title != product.title)
            modelLink.href = product.otherColorProducts.find((product) => product.title == review.product_title).url;

          let title = null;
          let body = null;
          let originalTitle = null;
          let originalBody = null;
          
          const siteLocale = Shopify.locale.toUpperCase();
          if (review.lang == siteLocale) {
            title = review.title;
            body = review.body;
          }
          else {
            const translation = review.translations.find((translation) => translation.lang == siteLocale);
            if (translation != null){
              title = translation.title;
              body = translation.body;
              originalTitle = review.title;
              originalBody = review.body;
            }
            //If no translation was found for it just show the original since this should only happens if there is no text to translate (emojis only for exemple)
            else{
              title = review.title;
              body = review.body;
            }
          }
          //Filling review title
          newReviewEl.querySelector(".review-entry-title").innerText = title;
          //Filling review body
          newReviewEl.querySelector(".review-entry-body").innerText = body;
          //Hide original language section if already in original language
          const originalLanguageWrapper = newReviewEl.querySelector(".review-original-language");
          if (originalTitle || originalBody)
          {
            originalLanguageWrapper.classList.remove("d-none");
            newReviewEl.querySelector(".review-entry-original-title").innerText = originalTitle;
            newReviewEl.querySelector(".review-entry-original-body").innerText = originalBody;
          }
          else originalLanguageWrapper.classList.add("d-none");
        });
        //Remove loading animations
        loadingAnimationReviews(false);
        royerReviewsLoadMoreBtn.disabled = false;
        royerReviewsLoadMoreBtnText.classList.remove("invisible");
        royerReviewsLoadMoreBtnSpinner.classList.add("d-none");
        
        //Increment current page
        reviewListCrtPage++;
      }
      else {
        royerReviewsErrorToastBootstrap.show();
      }
    })
    .catch((error) => {
      //Hide the loader again
      writeAReviewModalLoader.classList.remove("show");
      royerReviewsErrorToastBootstrap.show();
      console.log(error);
    });
}

//If no showLoading parameter is passed it will act as a toggle
function loadingAnimationReviews(showLoading) {
  const realReviews = Array.from(document.querySelectorAll(".review-entry-wrapper:not(.review-placeholder,#review-entry-wrapper-template)"));
  realReviews.forEach((review) => {
    if (showLoading == undefined) review.classList.toggle("d-none");
    else if (showLoading) review.classList.add("d-none");
    else review.classList.remove("d-none");
  });
  if (showLoading == undefined)
    royerReviewplaceholders.forEach((placeholder) =>
      placeholder.classList.toggle("d-none")
    );
  else if (showLoading)
    royerReviewplaceholders.forEach((placeholder) =>
      placeholder.classList.remove("d-none")
    );
  else
    royerReviewplaceholders.forEach((placeholder) =>
      placeholder.classList.add("d-none")
    );
}
